import { render, staticRenderFns } from "./MainTheme.vue?vue&type=template&id=7fb2ace6&"
import script from "./MainTheme.vue?vue&type=script&lang=js&"
export * from "./MainTheme.vue?vue&type=script&lang=js&"
import style0 from "./MainTheme.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports